import { createContext } from "react"

export const initialState = {
    filters: null,
}

const initialDispatch = {}

export const VerticalSigningStateContext = createContext(initialState)
export const VerticalSigningDispatchContext = createContext(initialDispatch)
